import { gate as v3Gate } from 'hub-http/gates';
import { usePermissionsContext } from '../context/PermissionsContext';

/**
 * Returns true if the current authed user has the provided gate
 */
export const useHasGate = gate => {
  const {
    gates
  } = usePermissionsContext();
  return gates.has(gate);
};
export function useHasContractM2Gate() {
  const hasPrivateBetaGate = useHasGate(v3Gate('Commerce:Contracts:PrivateBeta'));
  const hasM2Gate = useHasGate(v3Gate('Commerce:Contracts:M2:ChangesWithoutProration'));
  return hasPrivateBetaGate && hasM2Gate;
}